
import { useContext, useEffect, useMemo } from "react";
import styles from "./index.module.scss"
import { CheckCircleFilled } from '@ant-design/icons';
import Examples from "@utils/ExampleDataSet";
import Diagrams from "@utils/DiagramDataSet";
import { IMAGE_TYPE, CLOTH_COLOR_TYPE, POSE_FANTASY_MODE } from "@utils/CONST";
import Utils from "@utils/utils";
import { GenerateContext } from "../../hooks/GenerateContext";
import { AppContext } from '@utils/AppContext';
import Iconfont from '@utils/Iconfont';
import { Button } from 'antd';
import eventBus from '@utils/eventBus';
const VIDEO_BASE_URL = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/video/image2videoSample/";
const VIDEO_BASE_URL2 = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/video/tryonVideo/";
const GRASS_PLANT_BASE_URL = "https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/grassPlant/";
const TRYON_VIDEO_PROMPT = [
    '对镜展示服装',
    '转身摸头，向后走，回头',
    '镜头拉近，右手抚摸脖子',
    '轻微摆动身体',
    '转身摆姿势',
    '转身手模侧脸',
    '走秀',
    '转身展示衣服',
    '摸头转身',
    '站立摆姿势',
]
const IMAGE_TO_VIDEO = [
    '镜头不变，击打网球',
    '模特轻微摆动，慢动作，动作自然',
    '模特看向右方，镜头不变，海水波动',
    '女孩坐在网球框上，轻微晃腿，看向上方微笑',
    '男童向前走，抓起地上的雪微笑',
    '镜头不变，摘下眼镜',
    '抱猫，微笑',
    '镜头保持不变，女孩看着镜头微笑',
    '模特扶眼镜看镜头微笑，慢动作，动作自然',
    '模特轻微摆动，看向水杯，慢动作，动作自然',
]

export default function PlaceholderPage({ imageType, inputType }) {
    const {
        // 项目id
        projectId, setProjectId,
        // 输入图/单件服装
        inputImage, setInputImage,
        // 输入图宽度
        inputImageWidth, setInputImageWidth,
        // 输入图高度
        inputImageHeight, setInputImageHeight,
        // 输入图原始mask
        inputImageOriginalMask, setInputImageOriginalMask,
        // 输入图编辑后的mask
        inputImageEditedMask, setInputImageEditedMask,
        // 输入图分割id
        inputImageMaskId, setInputImageMaskId,
        // 输入图npy算法id
        inputImageNpyId, setInputImageNpyId,

        // 仅AI模特
        inputImageColorMaskId, setInputImageColorMaskId,

        // 仅AI试衣
        inputImageClothType, setInputImageClothType,
        topInputImage, setTopInputImage,
        // 顶部输入图宽度
        topInputImageWidth, setTopInputImageWidth,
        // 顶部输入图高度
        topInputImageHeight, setTopInputImageHeight,
        // 顶部输入图原始mask
        topInputImageOriginalMask, setTopInputImageOriginalMask,
        topInputImageEditedMask, setTopInputImageEditedMask,
        topInputImageMaskId, setTopInputImageMaskId,
        topInputImageNpyId, setTopInputImageNpyId,
        bottomInputImage, setBottomInputImage,
        // 底部输入图宽度
        bottomInputImageWidth, setBottomInputImageWidth,
        // 底部输入图高度
        bottomInputImageHeight, setBottomInputImageHeight,
        // 底部输入图原始mask
        bottomInputImageOriginalMask, setBottomInputImageOriginalMask,
        bottomInputImageEditedMask, setBottomInputImageEditedMask,
        bottomInputImageMaskId, setBottomInputImageMaskId,
        bottomInputImageNpyId, setBottomInputImageNpyId,

        // 仅鞋子上脚
        // 多视角图
        no1MultiAngleImage, setNo1MultiAngleImage,
        // 多视角图宽度
        no1MultiAngleImageWidth, setNo1MultiAngleImageWidth,
        // 多视角图高度
        no1MultiAngleImageHeight, setNo1MultiAngleImageHeight,
        no1MultiAngleImageMaskId, setNo1MultiAngleImageMaskId,
        // 多视角图原始mask
        no1MultiAngleImageOriginalMask, setNo1MultiAngleImageOriginalMask,
        no1MultiAngleImageEditedMask, setNo1MultiAngleImageEditedMask,
        no1MultiAngleImageNpyId, setNo1MultiAngleImageNpyId,
        // 多视角图
        no2MultiAngleImage, setNo2MultiAngleImage,
        // 多视角图宽度
        no2MultiAngleImageWidth, setNo2MultiAngleImageWidth,
        // 多视角图高度
        no2MultiAngleImageHeight, setNo2MultiAngleImageHeight,
        no2MultiAngleImageMaskId, setNo2MultiAngleImageMaskId,
        // 多视角图原始mask
        no2MultiAngleImageOriginalMask, setNo2MultiAngleImageOriginalMask,
        no2MultiAngleImageEditedMask, setNo2MultiAngleImageEditedMask,
        no2MultiAngleImageNpyId, setNo2MultiAngleImageNpyId,

        // 仅商品
        // 输入图的位置、缩放、尺寸、旋转等信息 (原dragScaleRef.current)
        inputImageTransform, setInputImageTransform,

        // 资源筛选
        resourceFilter, setResourceFilter,
        // 输入图多语义id
        inputImageMultiSemanticId, setInputImageMultiSemanticId,

        getModelColorMaskId,
        getClothMaskId,
        getShoesMaskId,
        getSemanticSimTryonMaskId,
        getSemanticSimTryonMaskIdClothTypeAll,
        getModelMaskId,
        getGoodsMaskId,
        currentClothColorType,
        setClothReColorIsPerson,
        currentPoseFantasyMode,
        setPrompt,
        videoKeyList, setVideoKeyList,
        setSceneKeyList,
    } = useContext(GenerateContext)
    const { isProEnv } = useContext(AppContext)
    const isSmartDetailPage = imageType == IMAGE_TYPE.SMART_DETAILA_PAGE
    // const requireList = ["单件商品", "商品清晰", "商品无遮挡"]

    const requireList = useMemo(() => {
        if (imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.POSE_TRYON || imageType == IMAGE_TYPE.BACKGROUND) {
            return ["单人图片", "完整清晰", '光线充足']
        } else if (imageType == IMAGE_TYPE.SHOES) {
            return ["侧面俯拍", "完整清晰", '同款同色']
        } else if (imageType == IMAGE_TYPE.MODEL_VIDEO || imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) {
            return ["单人正面站立", "露出完整身体", '背景简单']
        } else if (imageType == IMAGE_TYPE.GLASSES_TRYON) {
            return ["单张商品图", "画面清晰", '眼镜无遮挡']
        } else if (imageType == IMAGE_TYPE.NECKLACE_TRYON) {
            return ["单张商品图", "画面清晰", '项链无遮挡']
        } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR) {
            return ["完整清晰", "光线充足"]
        } else if (imageType == IMAGE_TYPE.WATERMARK_REMOVE) {
            return ["水印图", "营销文字", "电商贴片", "介绍贴片", "设计装饰"]
        } else if (imageType == IMAGE_TYPE.SMART_DETAILA_PAGE) {
            return ['模特图', '衣服图']
        } else {
            return ["单件商品图", "商品清晰", "商品无遮挡"]
        }
    }, [imageType])

    const examplesList = useMemo(() => {
        if (imageType == IMAGE_TYPE.CLOTHES || imageType == IMAGE_TYPE.SHOES) {
            return Examples[imageType][inputType]
        } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR && currentClothColorType == CLOTH_COLOR_TYPE.CLOTH_RECOLOR) {
            return Examples[imageType]
        } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR && currentClothColorType == CLOTH_COLOR_TYPE.SIM_RECOLOR) {
            return Examples[CLOTH_COLOR_TYPE.SIM_RECOLOR]
        } else {
            return Examples[imageType] || []
        }
    }, [imageType, inputType, currentClothColorType, isSmartDetailPage])

    const diagrams = useMemo(() => {
        if (isSmartDetailPage) {
            return Diagrams[IMAGE_TYPE.SMART_DETAILA_PAGE] || Diagrams[IMAGE_TYPE.GRASS_PLANT]
        }
        if (imageType == IMAGE_TYPE.CLOTHES || imageType == IMAGE_TYPE.SHOES) {
            return Diagrams[imageType][inputType]
        } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR && currentClothColorType == CLOTH_COLOR_TYPE.CLOTH_RECOLOR) {
            return Diagrams[imageType]
        } else if (imageType == IMAGE_TYPE.CLOTH_RECOLOR && currentClothColorType == CLOTH_COLOR_TYPE.SIM_RECOLOR) {
            return Diagrams[CLOTH_COLOR_TYPE.SIM_RECOLOR]
        } else if (imageType == IMAGE_TYPE.POSE_TRYON && currentPoseFantasyMode == POSE_FANTASY_MODE.FREEMODE) {
            const _diagram = JSON.parse(JSON.stringify(Diagrams[IMAGE_TYPE.POSE_TRYON]))
            if (_diagram?.input?.[1]) {
                _diagram.input[1].name = "输入提示词"
                _diagram.input[1].urls = ['https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/diagrams/pose_tryon_sample_1.png']
            }
            return _diagram
        } else {
            return Diagrams[imageType]
        }
    }, [imageType, inputType, currentClothColorType, currentPoseFantasyMode, isSmartDetailPage])

    // 点击示例图片
    const handleClick = async (item, exampleIndex) => {
        if (isSmartDetailPage) {
            const imageUrl = item?.inputImage
            if (!imageUrl) return
            eventBus.emit('smartDetailPlaceholderSelectImage', {
                url: imageUrl,
                name: item?.name || '示例图',
            })
            return
        }
        // 重置
        setProjectId()
        setInputImageOriginalMask()
        setInputImageEditedMask()
        setInputImageNpyId()
        setTopInputImageOriginalMask()
        setTopInputImageEditedMask()
        setTopInputImageNpyId()
        setBottomInputImageOriginalMask()
        setBottomInputImageEditedMask()
        setBottomInputImageNpyId()
        setNo1MultiAngleImageOriginalMask()
        setNo1MultiAngleImageEditedMask()
        setNo1MultiAngleImageNpyId()
        setNo2MultiAngleImageOriginalMask()
        setNo2MultiAngleImageEditedMask()
        setNo2MultiAngleImageNpyId()
        setInputImageTransform()
        if (imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.POSE_TRYON || imageType == IMAGE_TYPE.GLASSES_TRYON || imageType == IMAGE_TYPE.NECKLACE_TRYON || imageType == IMAGE_TYPE.BACKGROUND) {
            setInputImage(item.inputImage)
            setInputImageWidth(item.inputImageWidth)
            setInputImageHeight(item.inputImageHeight)
            const modelSex = imageType == IMAGE_TYPE.MODEL ? (exampleIndex === 2 ? '男' : '女') : null
            setResourceFilter(pre => ({
                ...pre,
                ...item.resourceFilter,
                ...(modelSex ? { model_sex: [modelSex], sex: [modelSex] } : {}),
            }))
            setInputImageOriginalMask(item.inputImageOriginalMask)
            // 测试环境需要重新获取
            if (isProEnv) {
                setInputImageMaskId(item.inputImageMaskId)
                setInputImageColorMaskId(item.inputImageColorMaskId)
            } else {
                const imageUrl = item.inputImage
                const maskId = await getModelMaskId(imageUrl)
                setInputImageMaskId(maskId)
                setInputImageColorMaskId(await getModelColorMaskId(imageUrl))
            }
        } else if (imageType == IMAGE_TYPE.SIM_TRYON || imageType == IMAGE_TYPE.FLATLAY3D) {
            setInputImage(item.inputImage)
            setInputImageWidth(item.inputImageWidth)
            setInputImageHeight(item.inputImageHeight)
            setInputImageClothType(item.inputImageClothType)
            setInputImageOriginalMask(item.inputImageOriginalMask)
            // 测试环境需要重新获取
            if (isProEnv) {
                setInputImageMaskId(item.inputImageMaskId)
            } else {
                const imageUrl = item.inputImage
                const maskId = await getClothMaskId(imageUrl)
                setInputImageMaskId(maskId)
            }
        } else if (imageType == IMAGE_TYPE.CLOTHES) {
            if (item.inputImage) {
                setInputImage(item.inputImage)
                setInputImageWidth(item.inputImageWidth)
                setInputImageHeight(item.inputImageHeight)
                setInputImageClothType(item.inputImageClothType)
                setInputImageOriginalMask(item.inputImageOriginalMask)
                // 测试环境需要重新获取
                if (isProEnv) {
                    setInputImageMaskId(item.inputImageMaskId)
                } else {
                    const imageUrl = item.inputImage
                    const maskId = await getClothMaskId(imageUrl)
                    setInputImageMaskId(maskId)
                }
            } else {
                setTopInputImage(item.topInputImage)
                setTopInputImageWidth(item.topInputImageWidth)
                setTopInputImageHeight(item.topInputImageHeight)
                setTopInputImageOriginalMask(item.topInputImageOriginalMask)
                // 测试环境需要重新获取
                if (isProEnv) {
                    setTopInputImageMaskId(item.topInputImageMaskId)
                } else {
                    const imageUrl = item.topInputImage
                    const maskId = await getClothMaskId(imageUrl)
                    setTopInputImageMaskId(maskId)
                }
                setBottomInputImage(item.bottomInputImage)
                setBottomInputImageWidth(item.bottomInputImageWidth)
                setBottomInputImageHeight(item.bottomInputImageHeight)
                setBottomInputImageOriginalMask(item.bottomInputImageOriginalMask)
                // 测试环境需要重新获取
                if (isProEnv) {
                    setBottomInputImageMaskId(item.bottomInputImageMaskId)
                } else {
                    const imageUrl = item.bottomInputImage
                    const maskId = await getClothMaskId(imageUrl)
                    setBottomInputImageMaskId(maskId)
                }
            }
        } else if (imageType == IMAGE_TYPE.SHOES) {
            setInputImage(item.inputImage)
            setInputImageWidth(item.inputImageWidth)
            setInputImageHeight(item.inputImageHeight)
            setInputImageOriginalMask(item.inputImageOriginalMask)
            // 测试环境需要重新获取
            if (isProEnv) {
                setInputImageMaskId(item.inputImageMaskId)
            } else {
                const imageUrl = item.inputImage
                const maskId = await getShoesMaskId(imageUrl)
                setInputImageMaskId(maskId)
            }
            if (item.no1MultiAngleImage) {
                setNo1MultiAngleImage(item.no1MultiAngleImage)
                setNo1MultiAngleImageWidth(item.no1MultiAngleImageWidth)
                setNo1MultiAngleImageHeight(item.no1MultiAngleImageHeight)
                setNo1MultiAngleImageOriginalMask(item.no1MultiAngleImageOriginalMask)
                // 测试环境需要重新获取
                if (isProEnv) {
                    setNo1MultiAngleImageMaskId(item.no1MultiAngleImageMaskId)
                } else {
                    const imageUrl = item.no1MultiAngleImage
                    const maskId = await getShoesMaskId(imageUrl)
                    setNo1MultiAngleImageMaskId(maskId)
                }
            }
            if (item.no2MultiAngleImage) {
                setNo2MultiAngleImage(item.no2MultiAngleImage)
                setNo2MultiAngleImageWidth(item.no2MultiAngleImageWidth)
                setNo2MultiAngleImageHeight(item.no2MultiAngleImageHeight)
                setNo2MultiAngleImageOriginalMask(item.no2MultiAngleImageOriginalMask)
                // 测试环境需要重新获取
                if (isProEnv) {
                    setNo2MultiAngleImageMaskId(item.no2MultiAngleImageMaskId)
                } else {
                    const imageUrl = item.no2MultiAngleImage
                    const maskId = await getShoesMaskId(imageUrl)
                    setNo2MultiAngleImageMaskId(maskId)
                }
            }
        } else if (imageType == IMAGE_TYPE.IMAGE_TO_VIDEO || imageType == IMAGE_TYPE.WATERMARK_REMOVE) {
            setInputImage(item.inputImage)
            setInputImageWidth(item.inputImageWidth)
            setInputImageHeight(item.inputImageHeight)
            setPrompt(IMAGE_TO_VIDEO[item.index])
        } else if (imageType == IMAGE_TYPE.MODEL_VIDEO) {
            setInputImage(item.inputImage)
            setInputImageWidth(item.inputImageWidth)
            setInputImageHeight(item.inputImageHeight)
            setPrompt(TRYON_VIDEO_PROMPT[item.index])
            setVideoKeyList([...item.refList])
        } else if (imageType == IMAGE_TYPE.COMMODITY) {
            setInputImage(item.inputImage)
            setInputImageWidth(item.inputImageWidth)
            setInputImageHeight(item.inputImageHeight)
            setInputImageOriginalMask(item.inputImageOriginalMask)
            setResourceFilter(pre => ({ ...pre, ...item.resourceFilter }))
            // 测试环境需要重新获取
            if (isProEnv) {
                setInputImageMaskId(item.inputImageMaskId)
            } else {
                const imageUrl = item.inputImage
                const maskId = await getGoodsMaskId(imageUrl)
                setInputImageMaskId(maskId)
            }
        } else if (imageType == IMAGE_TYPE.COMMODITYRECOLOR || imageType == IMAGE_TYPE.CLOTH_RECOLOR) {
            setInputImage(item.inputImage)
            setInputImageWidth(item.inputImageWidth)
            setInputImageHeight(item.inputImageHeight)
            setInputImageOriginalMask(item.inputImageOriginalMask)
            if (item.clothReColorIsPerson) setClothReColorIsPerson(item.clothReColorIsPerson)

            // 测试环境需要重新获取
            if (isProEnv) {
                setInputImageMaskId(item.inputImageMaskId)
                if (item.inputImageMultiSemanticId) setInputImageMultiSemanticId(item.inputImageMultiSemanticId)
            } else {
                const imageUrl = item.inputImage
                const maskId = await getShoesMaskId(imageUrl)
                setInputImageMaskId(maskId)
                if (item.inputImageMultiSemanticId) { // 多语义
                    const res = await getSemanticSimTryonMaskIdClothTypeAll(imageUrl)
                    const ids = res.split(":")
                    const semanticMaskId = ids[1]
                    setInputImageMultiSemanticId(semanticMaskId)
                }
            }
        } else if (imageType == IMAGE_TYPE.GRASS_PLANT) {
            setInputImage(item.inputImage)
            setInputImageWidth(item.inputImageWidth)
            setInputImageHeight(item.inputImageHeight)
            setSceneKeyList([...item.sceneKeyList])
        }
    }

    return (
        <div className={`${styles.PlaceholderPage} _beauty_scrollbar`}>
            <div className={styles.DiagramContainer}>
                <div className={styles.InputContainer}>
                    {diagrams.input.map(item => (
                        <div className={styles.DiagramItem} key={item.name}>
                            <div className={styles.ImageList}>
                                {item.urls.map(url => (
                                    <div className={`${styles.ImageItem} ${item.multiple ? styles.multiple : ""}`} key={url}>
                                        <img src={Utils.getImgThumbnail(url)} />
                                    </div>
                                ))}
                            </div>
                            <span>{item.name}</span>
                        </div>
                    ))}
                </div>
                <div className={styles.OuputContainer}>
                    <div className={styles.DiagramItem}>
                        <div className={styles.ImageList}>
                            <div className={styles.ImageItem}>
                                {
                                    diagrams.output.video ?
                                        <video src={diagrams.output.url} autoPlay loop muted /> :
                                        <img src={Utils.getImgThumbnail(diagrams.output.url)} />
                                }
                            </div>
                        </div>
                        <span>{diagrams.output.name}</span>
                        <Iconfont type="icon-TransformArrow" className={styles.TransformArrow} />
                        <Iconfont type="icon-MultiStar" className={styles.MultiStar} />
                    </div>
                </div>
            </div>
            {
                imageType == IMAGE_TYPE.IMAGE_TO_VIDEO || imageType == IMAGE_TYPE.MODEL_VIDEO ?
                    <div className={`${styles.videoSampleWrap}`}>
                        <p>优秀案例</p>
                        <div className={`${styles.videoSampleList}`}>
                            {
                                Array.from({ length: 10 }).map((_, index) => {
                                    const videoUrl = imageType == IMAGE_TYPE.IMAGE_TO_VIDEO ? VIDEO_BASE_URL : VIDEO_BASE_URL2
                                    return (
                                        <div className={styles.videoSampleItem} key={index}
                                            onClick={() => handleClick({
                                                inputImage: videoUrl + (index + 1) + ".png",
                                                refList: [{
                                                    url: videoUrl + (index + 1) + ".mp4",
                                                    custom: 0,
                                                    attr: { duration: 5000 }
                                                }],
                                                inputImageWidth: 1728,
                                                inputImageHeight: 2304,
                                                index: index
                                            })}>
                                            <video src={videoUrl + (index + 1) + ".mp4"} autoPlay loop muted />
                                            <img className={styles.smallImg} src={Utils.getImgThumbnail(videoUrl + (index + 1) + ".png")} />
                                            <Button type="primary" className={styles.doSameBtn}>做同款</Button>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div> :
                    imageType == IMAGE_TYPE.GRASS_PLANT ?
                        <div className={`${styles.videoSampleWrap}`}>
                            <p>优秀案例</p>
                            <div className={`${styles.videoSampleList}`}>
                                {
                                    Array.from({ length: 10 }).map((_, index) => {
                                        return (
                                            <div className={styles.videoSampleItem} key={index}
                                                onClick={() => handleClick({
                                                    inputImage: GRASS_PLANT_BASE_URL + (index + 1) + ".jpg",
                                                    sceneKeyList: [{
                                                        url: GRASS_PLANT_BASE_URL + (index + 1) + "-1.jpg",
                                                        custom: 1,
                                                    }],
                                                    inputImageWidth: 1728,
                                                    inputImageHeight: 2304,
                                                    index: index
                                                })}
                                            >
                                                <img className={styles.grassPlantImg} src={Utils.getImgThumbnail(GRASS_PLANT_BASE_URL + (index + 1) + "-2.jpg")} />
                                                <img className={styles.smallImg2} src={Utils.getImgThumbnail(GRASS_PLANT_BASE_URL + (index + 1) + ".jpg")} />
                                                <img className={styles.smallImg3} src={Utils.getImgThumbnail(GRASS_PLANT_BASE_URL + (index + 1) + "-1.jpg")} />
                                                <Button type="primary" className={styles.doSameBtn}>做同款</Button>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div> :
                        <div className={styles.ExampleContainer}>
                            <div className={styles.ExampleTitle}>初次使用？试试这些</div>
                            <div className={styles.ExampleList}>
                                {
                                    examplesList.map((item, index) => (
                                        <div className={styles.ExampleItem} key={item.inputImage} onClick={() => handleClick(item, index)}>
                                            {item.inputImage && <img src={Utils.getImgThumbnail(item.inputImage)} />}
                                            {item.topInputImage && <img src={Utils.getImgThumbnail(item.topInputImage)} />}
                                            {item.bottomInputImage && <img src={Utils.getImgThumbnail(item.bottomInputImage)} />}
                                            {item.no1MultiAngleImage && <img src={Utils.getImgThumbnail(item.no1MultiAngleImage)} />}
                                            {item.no2MultiAngleImage && <img src={Utils.getImgThumbnail(item.no2MultiAngleImage)} />}
                                        </div>
                                    ))
                                }
                            </div>
                            <div className={styles.RequireList}>
                                {
                                    requireList?.map(item => (
                                        <div className={styles.RequireItem} key={item}>
                                            <CheckCircleFilled />
                                            <span>{item}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
            }
        </div>
    )
}
